export default "__VITE_ASSET__Vme$A_1m__"